import React from 'react'
import './ConstructionChemicals.scss'
import SupplementaryServices from '../components/SupplementaryServices'

const ConstructionChemicals = () => {

    let mapData = {
        title: "Construction <span> Chemicals</span>",
        desc: "Hutaib Industrial Solutions offers a broad spectrum of top-tier chemicals, developed to meet the dynamic needs of multiple industries.",
        mapItem: [

            {
                title: 'Epoxy Resin',
                description: 'A high-strength bonding agent ideal for structural repairs, coatings, and chemical-resistant applications.',
                slug: 'epoxy-resin',
                localImage: '/assets/images/Epoxy.webp'
            }, {
                title: 'Admixture',
                description: 'A performance-enhancing additive that improves concrete workability, strength, and setting time.',
                slug: 'admixture',
                localImage: '/assets/images/admixture.webp'
            },
            {
                title: 'RDP Grades',
                description: 'Redispersible Polymer Powders (RDP) enhance mortar flexibility, adhesion, and crack resistance. They are perfect for tile adhesives, renders, and self-leveling compounds.',
                slug: 'rdp-grades',
                localImage: '/assets/images/RDPGRADES.webp'
            },
            {
                title: 'SBR Grades',
                description: 'SBR (Styrene-Butadiene Rubber) grades provide high elasticity, abrasion resistance, and bonding strength. Commonly used in adhesives, sealants, and flooring applications.',
                slug: 'sbr-grades',
                localImage: '/assets/images/SBRGRADES.webp'
            },
            {
                title: 'Styrene Acrylic',
                description: 'Styrene acrylic polymers offer excellent adhesion, water resistance, and flexibility. Ideal for coatings, paints, and construction emulsions.',
                slug: 'styrene-acrylic',
                localImage: '/assets/images/StyreneAcrylic.webp'
            },
        ]
    }

    return (
        <div className='Wrapme'>
            <SupplementaryServices data={mapData} />
        </div>
    )
}

export default ConstructionChemicals